import { render, staticRenderFns } from "./JobSet.vue?vue&type=template&id=4b8ba815&scoped=true&"
import script from "./JobSet.vue?vue&type=script&lang=js&"
export * from "./JobSet.vue?vue&type=script&lang=js&"
import style0 from "./JobSet.vue?vue&type=style&index=0&id=4b8ba815&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8ba815",
  null
  
)

export default component.exports